import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../constants/api.constants';
import { AuthenticationFeatureService } from '../features/authentication-feature/authentication-feature.service';
import { RoutesConstants } from '../constants/routes.constants';

interface MasterTeamMember {
  email: string;
  role: string;
}

interface MasterTeamMembersRoot {
  value: MasterTeamMember[];
}

export const projectManagerGuard: CanActivateFn = () => {
  const authFeature = inject(AuthenticationFeatureService);
  const httpClient = inject(HttpClient);
  const router = inject(Router);

  const email = authFeature.getInstance().getActiveAccount()?.username ?? '';
  const url = `${ApiConstants.MASTER_TEAM_MEMBERS_URL}?$filter=email eq '${email}'`;

  return httpClient.get<MasterTeamMembersRoot>(url).pipe(
    map((res) => {
      const isProjectManager = res.value.some((m) => m.role === 'Project_x0020_Manager');
      if (isProjectManager) return true;
      router.navigate([RoutesConstants.UNAUTHORIZED_URL]);
      return false;
    }),
    catchError(() => {
      router.navigate([RoutesConstants.UNAUTHORIZED_URL]);
      return of(false);
    }),
  );
};
